import { InputBaseComponentProps } from '@mui/material';
import { forwardRef, useState } from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';
import { US_PHONE_CODE } from 'src/components/Forms/const';
import { removeCodeFromPhoneNumber } from 'src/components/Forms/utils';

type OnChangeCustomEvent = (event: { target: { value: string } }) => void;

export const PHONE_FORMAT = `${US_PHONE_CODE} (###) ### ####`;

export const FormattedPhoneInput = forwardRef<PatternFormatProps, InputBaseComponentProps>(
  function FormattedPhoneInput({ onChange, onBlur, ...props }, ref) {
    const [value, setValue] = useState<string>(props.defaultValue as string);
    return (
      <PatternFormat
        {...props}
        allowEmptyFormatting
        getInputRef={ref}
        type={props.type as PatternFormatProps['type']}
        defaultValue={props.defaultValue as string}
        // Override onBlur event to include unformatted value.
        onBlur={(event) => {
          (onBlur as OnChangeCustomEvent)({
            ...event,
            target: {
              ...event.target,
              value,
            },
          });
        }}
        // invoke onChange event handler with unformatted value.
        onValueChange={(values, sourceInfo) => {
          setValue(values.value);
          (onChange as OnChangeCustomEvent)({
            ...sourceInfo.event,
            target: {
              ...sourceInfo.event?.target,
              value: values.value,
            },
          });
        }}
        onPaste={(event) => {
          const digits = event.clipboardData.getData('text').replace(/\D/g, '');
          const phoneNumber = removeCodeFromPhoneNumber(digits);
          if (phoneNumber === digits) return;
          event.preventDefault();
          setValue(phoneNumber);
          (onChange as OnChangeCustomEvent)({
            ...event,
            target: {
              ...event.target,
              value: phoneNumber,
            },
          });
        }}
        format={PHONE_FORMAT}
      />
    );
  },
);
